import { useState } from "react";
import { videos } from "@/mocks/guagua";
import SectionHeading from "./SectionHeading";

const filters = ["全部", "明星八卦", "社会热点", "娱乐综艺", "科技奇闻", "体育赛场", "民生趣闻"];

function Videos() {
  const [active, setActive] = useState("全部");
  const [openId, setOpenId] = useState<number | null>(null);

  const list = active === "全部" ? videos : videos.filter((v) => v.category === active);

  const togglePlay = (id: number) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  return (
    <section id="video" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="焦点事件短视频"
          title="事件现场 一网打尽"
          desc="精选全网高热度事件短视频，覆盖现场直击、名场面、热议大瓜，点开即可围观事件全过程。"
          linkHref="#topic"
          linkLabel="阅读深度专题"
        />

        <div className="mb-7 flex flex-wrap gap-2">
          {filters.map((f) => (
            <button
              key={f}
              type="button"
              onClick={() => setActive(f)}
              className={`rounded-full px-4 py-1.5 text-sm whitespace-nowrap transition-colors ${
                active === f
                  ? "bg-accent-500 text-background-50"
                  : "bg-background-100 text-foreground-600 hover:bg-background-200"
              }`}
            >
              {f}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {list.map((video, idx) => (
            <article
              key={video.title}
              className="group overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-all hover:-translate-y-1 hover:border-primary-200"
            >
              <div
                className="relative aspect-video w-full cursor-pointer overflow-hidden"
                onClick={() => togglePlay(idx)}
              >
                <img
                  src={video.image}
                  alt={`${video.title} 事件短视频`}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black/0 transition-colors group-hover:bg-black/20"></div>

                <span className="absolute left-2 top-2 rounded-md bg-primary-500 px-2 py-0.5 text-xs text-background-50">
                  {video.category}
                </span>
                <span className="absolute left-2 top-9 rounded bg-black/50 px-1.5 py-0.5 text-[11px] text-background-50">
                  {video.tag}
                </span>
                <span className="absolute right-2 bottom-2 rounded bg-black/60 px-1.5 py-0.5 text-[11px] text-background-50">
                  {video.duration}
                </span>

                <span className="absolute inset-0 flex items-center justify-center">
                  <span
                    className={`grid h-12 w-12 items-center justify-center rounded-full bg-background-50/90 text-primary-600 shadow-lg transition-transform ${
                      openId === idx ? "scale-110" : "opacity-0 group-hover:opacity-100"
                    }`}
                  >
                    <i
                      className={`${openId === idx ? "ri-pause-fill" : "ri-play-fill"} text-xl`}
                      aria-hidden="true"
                    ></i>
                  </span>
                </span>
              </div>

              <div className="flex flex-col gap-2 p-4">
                <h3 className="line-clamp-2 text-sm md:text-base text-foreground-800">
                  {video.title}
                </h3>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-eye-line" aria-hidden="true"></i>
                    {video.views} 播放
                  </span>
                  <span className="inline-flex items-center gap-1 text-primary-700">
                    <i className="ri-fire-fill text-accent-500" aria-hidden="true"></i>
                    {video.heat}热度
                  </span>
                  <span>{video.date}</span>
                </div>
              </div>

              {openId === idx && (
                <div className="border-t border-background-100 px-4 py-3 text-xs text-foreground-600">
                  视频正为你加载播放中，稍后将自动开始播放事件现场画面…
                </div>
              )}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Videos;